export default __webpack_public_path__ + "static/media/certificateImg.0317cd8a.png";